import React from "react";

// Components
import { IonRouterOutlet } from "@ionic/react";
import { Route } from "react-router-dom";

/* Listeners */
import AppUrlListener from "../listeners/AppUrlListener";

// Pages
import { IonReactRouter } from "@ionic/react-router";
import Login from "../pages/Entry/Login";
import Register from "../pages/Register/Register";
import SelectMemberType from "../pages/Register/SelectMemberType";
import SignOut from "../pages/SignOut/SignOut";

export const DefaultRouter: React.FC = () => (
  <IonReactRouter>
    <AppUrlListener />
    <IonRouterOutlet id="main">
      <Route path="/" component={Login} exact />
      <Route path="/admin" component={Login} exact />
      <Route path="/register" component={SelectMemberType} exact />
      <Route path="/register/:id/:name" component={Register} exact />
      <Route path="/sign-out" component={SignOut} exact />
    </IonRouterOutlet>
  </IonReactRouter>
);
